import { render, staticRenderFns } from "./Realtime_Alert_View.vue?vue&type=template&id=0b35478c&"
import script from "./Realtime_Alert_View.vue?vue&type=script&lang=js&"
export * from "./Realtime_Alert_View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports